import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, Form, FormGroup, Label } from 'reactstrap';
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

import useDatePickerPortal from '../../utils/useDatePickerPortal'

const fromDate = d => d ? [d.getFullYear(), String(d.getMonth() + 1).padStart(2, '0'), String(d.getDate()).padStart(2, '0')].join('-') : ''

const AttendeeDetails = (props) => {
    const datePickerPortal = useDatePickerPortal()
    const [name, setName] = useState(null)
    const [dob, setDob] = useState(null)
    const [validId, setValidId] = useState(null)

    const submitHandler = (e) => {
        e.preventDefault()
        props.addGuest({ name, dob: fromDate(dob), validId })
        props.toggle()
        setName(null)
        setDob(null)
        setValidId(null)
    }

    return (
        <div>
            <Modal isOpen={props.modal} toggle={props.toggle}>
                <Form onSubmit={submitHandler}>
                    <ModalHeader toggle={props.toggle}><b>Attendee Details</b></ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <Label>Full Name as per ID</Label>
                            <Input
                                type='text'
                                onChange={e => setName(e.target.value)}
                                value={name}
                                required
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Date of Birth</Label>
                            <DatePicker
                                selected={dob}
                                onChange={d => setDob(d)}
                                dateFormat="dd/MM/yyyy"
                                maxDate={new Date()}
                                showYearDropdown
                                scrollableYearDropdown
                                yearDropdownItemNumber={100}
                                className="form-control"
                                wrapperClassName="d-block"
                                placeholderText="Select date of birth"
                                {...datePickerPortal}
                                required
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Passport/IC*</Label>
                            <Input
                                type='text'
                                onChange={e => setValidId(e.target.value)}
                                value={validId}
                                required
                            />
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" type='submit'>Accept</Button>{' '}
                        <Button color="secondary" onClick={props.toggle}>Close</Button>
                    </ModalFooter>
                </Form>
            </Modal>
        </div>
    );
}

export default AttendeeDetails;